import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { GroupOrderBagButton } from '../GroupOrderBagButton/GroupOrderBagButton';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagShareButton = (props: Props) => {
  const { isDisabled, onPress } = props;

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <GroupOrderBagButton icon="IconShare2" isDisabled={isDisabled} onPress={onPress}>
      <FormattedMessage {...messages.label} />
    </GroupOrderBagButton>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  label: {
    defaultMessage: 'Invite others',
    description: 'Bag | Group order | Invite others CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  onPress: () => void;
};
